import React from 'react';
import { StyleSheet } from 'react-native'
import { Colors } from 'react-native-paper';
import { AppButton, AppText } from "../form";
import { pixelDimensions } from '../../config/utils';

const GreenButton = ({ onPress, label }) =>(
    <AppButton onPress={onPress} style={styles.button}>
        <AppText size='bold' style={styles.text}>{label}</AppText>
    </AppButton>
)

const styles = StyleSheet.create({
    button: {
        alignSelf: 'center',
        width: pixelDimensions(80),
        
        paddingHorizontal: pixelDimensions(6),
        marginVertical: pixelDimensions(2),
        paddingVertical: pixelDimensions(2),
        alignSelf: "center",    
    },
    text: {
        textAlign: "center",
        color: Colors.white,
        fontSize: pixelDimensions(5)
    }
})

export default GreenButton;
